import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { UserTable } from "./UserTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { addEmployee, addItem, resetData } from "./userSlice";
import {
  formLabelsTheme,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },

  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const UserCreate = ({
  isOpen,
  handleShow,
  handleClose,
  handleSearch,
  setFormValues,
  formValues,
  setFieldsCP,
  fieldsCP,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataParam = useSelector(selectParameter);
  const dataParam2 = useSelector(selectParameter2);
  const dataCountry = useSelector(selectCountryAll);

  const typePhone = dataParam2.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  function handlePhoneChange(i, event) {
    const values = [...fieldsCP];
    values[i].phone = event.target.value;
    setFieldsCP(values);
  }

  function handleAdd() {
    const values = [...fieldsCP];
    values.push({
      phone_type: "",
      phone: "",
    });
    setFieldsCP(values);
  }

  function handleRemove(i) {
    const values = [...fieldsCP];
    values.splice(i, 1);
    setFieldsCP(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fieldsCP];
    values[i].phone_type = event.value;
    setFieldsCP(values);
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeCountry = (e, country) => {
    const value = country.value;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (
      formValues.emp_id.value.includes("<script>") ||
      formValues.emp_id.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }
    if (
      formValues.first_name.value.includes("<script>") ||
      formValues.first_name.value.includes("</script>") ||
      formValues.last_name.value.includes("<script>") ||
      formValues.last_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (
      formValues.address1.value.includes("<script>") ||
      formValues.address1.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (!validatePost()) {
      return;
    }

    const params = {
      emp_id: formValues.emp_id.value,
      first_name: formValues.first_name.value,
      last_name: formValues.last_name.value,
      designation: formValues.designation.value,
      address1: formValues.address1.value,
      address2: formValues.address2.value,
      city: formValues.city.value,
      zipcode: formValues.zipcode.value,
      country_id: formValues.country_id.value,
      province: formValues.province.value,
      cp_email: formValues.email.value,

      contactpersons: fieldsCP.map((item, index) => {
        return {
          phone_type: item.phone_type,
          phone: item.phone,
        };
      }),
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addEmployee(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/administration/management-user/edit/${response.payload.data.data.id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;
  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.country_id.value
  );

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          New User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ThemeProvider theme={formLabelsTheme}>
          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                required
                label="Employee ID"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="emp_id"
                value={formValues.emp_id.value}
                onChange={handleChange}
                error={formValues.emp_id.error}
                helperText={
                  formValues.emp_id.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {icon} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
              <RedditTextField
                label="Job Role"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="designation"
                onChange={handleChange}
                value={formValues.designation.value}
              />
              <RedditTextField
                inputProps={{ maxLength: 512 }}
                required
                label="Address Line 1"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                multiline
                rows="4"
                name="address1"
                value={formValues.address1.value}
                onChange={handleChange}
                error={formValues.address1.error}
                helperText={
                  formValues.address1.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {icon} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
              <RedditTextField
                label="City"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="city"
                onChange={handleChange}
                value={formValues.city.value}
              />
              <RedditTextField
                label="Province"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="province"
                onChange={handleChange}
                value={formValues.province.value}
              />
            </Col>
            <Col xs={12} sm={3} md={6} lg={6}>
              {" "}
              <RedditTextField
                required
                label="First Name"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="first_name"
                value={formValues.first_name.value}
                onChange={handleChange}
                error={formValues.first_name.error}
                helperText={
                  formValues.first_name.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {icon} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
              <RedditTextField
                label="Last Name"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="last_name"
                onChange={handleChange}
                value={formValues.last_name.value}
              />
              <RedditTextField
                label="Address Line 2"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                multiline
                rows="4"
                name="address2"
                onChange={handleChange}
                value={formValues.address2.value}
              />
              <RedditTextField
                label="Zipcode"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="zipcode"
                onChange={handleChange}
                value={formValues.zipcode.value}
              />
              <Autocomplete
                disablePortal
                name="country_id"
                options={countryOptions}
                getOptionLabel={(option) => option.label.toString()}
                disableClearable={true}
                onChange={handleChangeCountry}
                value={countryOptions[index]}
                renderInput={(params) => (
                  <RedditTextField
                    required
                    className={classes.margin}
                    {...params}
                    label="Country"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    placeholder="Select Country"
                    name="country_id"
                    error={formValues.country_id.error}
                    helperText={
                      formValues.country_id.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {icon} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              />
            </Col>
          </Row>
          <p className="font-weight-bold  m-3">Contact Details :</p>

          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              {fieldsCP.map((field, idx) => {
                return (
                  <div key={`${field}-${idx}`}>
                    <Row>
                      <Col md={4}>
                        <Select
                          // isClearable={true}
                          options={typePhone}
                          value={getValueType(field.phone_type, typePhone)}
                          placeholder="Type"
                          onChange={(e) => handleTypeChange(idx, e)}
                          className="mt-4 ml-3"
                        />
                      </Col>
                      <Col md={6}>
                        <RedditTextField
                          inputProps={{
                            maxLength: 20,
                            onInput: (e) => {
                              if (e.target.value.length > 20) {
                                e.target.value = e.target.value.slice(0, 20);
                              }
                            },
                          }}
                          label="Phone Number"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="number"
                          size="small"
                          fullWidth
                          value={field.phone || ""}
                          onChange={(e) => handlePhoneChange(idx, e)}
                        />
                      </Col>
                      {fieldsCP.length !== 1 && (
                        <Col>
                          <div
                            className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 "
                            onClick={() => handleRemove(idx)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-light">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/X.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                      <Col sm={1}>
                        {fieldsCP.length - 1 === idx && (
                          <Button
                            variant="outline-primary"
                            onClick={(e) => handleAdd()}
                            className="mt-4 "
                          >
                            Add
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </Col>

            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                label="Email"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="email"
                onChange={handleChange}
                value={formValues.email.value}
              />
            </Col>
          </Row>
        </ThemeProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button onClick={handleSave} variant="primary">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
